export const downloadLinkIOSMobile = 'https://itunes.apple.com/app/id1157302846'
export const downloadLinkIOS = 'https://apps.apple.com/no/app/nio/id1157302846'
export const downloadLinkAndroid = 'https://play.google.com/store/apps/details?id=com.nio.nioapp'
export const PE_HOMEPAGE_URL = 'https://app.eu.nio.com/pe/niobiz/homespot/static/index.html'
export const PE_HOMEPAGE_ENV_URL = (env) => {
  return `https://app${env === 'prod' ? '' : `-${env}`}.eu.nio.com/pe/niobiz/homespot/static/index.html`
}
